module.exports = {
  api_base_url: process.env.REACT_APP_BASE_URL,
  authKey: process.env.REACT_APP_AUTH_KEY,
};
